import {useEffect, useContext, useState} from "react";
import {ThemeContext} from "../context/data/ThemeContext";

export function useBreadcrumb() {
    const { setBreadcrumb } = useContext(ThemeContext);
    const [breadcrumbObject, setBreadcrumbObject] = useState<any>({component: null});

    useEffect(() => {
        if (breadcrumbObject.component) {
            setBreadcrumb(breadcrumbObject);
        }
        return () => {
            setBreadcrumb({component: null});
        };
    }, [breadcrumbObject.component]);

    const setBreadcrumbComponent = (value) => {
        setBreadcrumbObject(value);
    }

    return { setBreadcrumbComponent }
}